import React from 'react';
//import Dash from '../components/Dashboard';
import Dash from '../../components/Dashboard';
// This is Dashboard Page
export default function DashboardPage() {
  return <Dash />;
}
